<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'employee.avatar.changePhoto' | translate }}</h2>
    </div>
    <div class="app-dialog__header-actions" *ngIf="localAvatar">
      <span class="data-source-type">{{ 'employee.local' | translate }}</span>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="avatar-uploader-content">
      <app-image-processing
        [imageUploadUrl]="avatarUploadUrl"
        [thumbnailPhotoUrl]="thumbnailPhotoUrl"
        [localAvatar]="localAvatar"
        (avatarSaved)="onAvatarSaved()">
      </app-image-processing>
    </div>
  </div>
</div>
